/* src/app/modules/ocrHistory/ocrHistory.component.css */
.example-icon {
  padding: 0 14px;
}
.toolbar-spacer {
  flex: 1 1 auto;
}
.index-row {
  flex: 5;
}
.index-button {
  flex: 1;
}
ul {
  list-style-type: none;
}
li {
  list-style-type: none;
  margin: auto 10px;
}
.example-container {
  display: flex;
  flex-direction: column;
  min-width: 300px;
}
.example-header {
  min-height: 64px;
  padding: 8px 24px 0;
}
.mat-mdc-form-field {
  font-size: 14px;
  width: 100%;
}
.mat-mdc-table {
  overflow: auto;
  max-height: 500px;
}
.dialog-container {
  height: 500px;
  overflow: auto;
}
/*# sourceMappingURL=ocrHistory.component.css.map */
